import { render, staticRenderFns } from "./NewCode.vue?vue&type=template&id=4dd264e4&scoped=true"
import script from "./NewCode.vue?vue&type=script&lang=js"
export * from "./NewCode.vue?vue&type=script&lang=js"
import style0 from "./NewCode.vue?vue&type=style&index=0&id=4dd264e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd264e4",
  null
  
)

export default component.exports